export default __webpack_public_path__ + "static/media/store_svg14.cf79b88b.svg";